import BootstrapTable from 'react-bootstrap-table-next';
import React from 'react';
import { Dropdown } from 'react-bootstrap'
import { connect } from "react-redux";
import './../main.scss'
import './table.scss'
import Pagination from "react-js-pagination";
import checkJwt from './../../../Global/jwtChecker' 
import logout from './../../../Global/logout'
import { AiFillEdit } from 'react-icons/ai'
import Loader from './../../../Global/loader'
import GetClientList from './../../../API/Admin/GetClientList'
import { RiDeleteBin5Line } from 'react-icons/ri'
import { Button } from 'react-bootstrap'
import deleteClient from './../../../API/Admin/DeleteClient.js'
import Modal from 'react-modal';
import { store } from 'react-notifications-component';

export class ClientList extends React.Component{
  constructor(props) {
    super(props)

    document.title= "Klijenti - Lista"

    this.state={
        loading: true,
        error: false,
        signin: true,
        racunVisible: false,
        oneInvoice: null,
        invoices: null, 
        showModal: false, 
        uuidForDelete: "",  
        deleteMessage: false, 
        customStyles: {
            content : {
              top                   : '50%',
              left                  : '50%',
              right                 : 'auto',
              bottom                : 'auto',
              //marginRight           : '-50%',
              transform             : 'translate(-50%, -50%)',
              color: 'red'
            }
        },
        

        columns:[{
            dataField: 'clientName',
            text: 'Naziv',
            style: {wordWrap: "break-word"},
            headerStyle: { wordWrap:  "break-word" },    
          }, {
            dataField: 'clientCountrySpecificVatNumber',
            text: 'OIB',
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
        }, {
            dataField: 'clientFullAddress',
            text: 'Adresa',
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
        }, {
          dataField: 'domainLabel',
          text: 'Domena',
          style: {wordWrap: "break-word"} ,
          headerStyle: { wordWrap:  "break-word" },          
        }, {
          dataField: 'inVatSystem',
          text: 'PDV',
          style: {wordWrap: "break-word"},
          formatter: (cellContent, row) => {          
            return (
              <div key={row.uuid} style={{wordWrap: "break-word"}}>
                  <span>{ row.inVatSystem ? "Da" : "Ne" }</span>
              </div>
            );
          }
        }, {
            dataField: 'pregled',
            isDummyField: true,
            text: '',
            style: {wordWrap: "break-word"},
            headerStyle: (colum, colIndex) => {
                return { width: '11em' };
            },
            formatter: (cellContent, row) => {          
              return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    <div 
                        className="btn btn-warning" 
                        id={row.uuid} 
                        onClick={() =>this.seeDetails(row.uuid)} 
                        style={{marginBottom: "10px", marginRight: "10px", fontSize: "13px"}}
                    > 
                        <AiFillEdit /> Detalji 
                    </div> 

                    <div 
                        className="btn btn-danger" 
                        id={row.uuid} 
                        onClick={() => this.showModal(row.uuid)}
                        style={{marginBottom: "10px", fontSize: "13px"}}
                    > 
                        <RiDeleteBin5Line /> Izbriši 
                    </div> 
                   
                </div>
                
              );
            }
          }         
        ]        
      } 
    }

    componentDidMount = async () => {
      this.props.mapState("ADMIN_MAP_LOADING_CLIENT", true)
      /*this.setState({
        loading: true
      })*/

      const unHashedJwt = await checkJwt()

      if(!unHashedJwt){
          logout()
      }

      
      //await this.getClientList()
      
      this.props.mapState("ADMIN_MAP_LOADING_CLIENT", false)
      
    }

    getClientList = async () =>{
      await this.props.mapState("ADMIN_MAP_LOADING_CLIENT", true)

      const unHashedJwt = await checkJwt()

      if(!unHashedJwt){
          logout()
      }

      const clientList = await GetClientList(
            this.props.activePage, 
            this.props.pageSize, 
            this.props.clientName,
            this.props.clientAddress,
            this.props.clientEmail,
            this.props.clientPhoneNumber,
            this.props.clientVAT,
            this.props.clientDomain,
            this.props.clientOIB
        )
      if(!clientList.error){           
          await this.props.mapState("ADMIN_MAP_CLIENT_LIST", clientList.data)             
      }
      else{
        logout()
      }
     
      this.props.mapState("ADMIN_MAP_LOADING_CLIENT", false)  
    }

    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleToggleSidebar(){
        this.props.mapState("ASIDE_TOGGLER", !this.props.asideToggled)
    }

    handlePageChange(pageNumber) {

      this.props.mapState("ADMIN_MAP_CLIENT_LIST_ACTIVE_PAGE", pageNumber)

      this.getClientList()
    }

    handleItemsPerPageChange(itemsPerPage) {
      this.setState({itemsPerPage: itemsPerPage});

      this.getClientList()
    }

    onItemsPerPageChange= async (size) =>{         
        this.props.mapState("ADMIN_MAP_CLIENT_LIST_PAGE_SIZE", size)

        this.getClientList()
    }

    seeDetails(data){
        window.location = "#/Admin/client/:" + data
    }

    showModal = uuid => {
        this.setState({
            showModal: !this.state.showModal,
            uuidForDelete: uuid
        });
      };

    confirmDelete = async () => {
        let deletedClient = await deleteClient(this.state.uuidForDelete)     
        if(deletedClient.data.operationResult === "SUCCESS"){
            this.setState({
                showModal: false,
                uuidForDelete: ""
            })     
            store.addNotification({
                title: "Uspješno!",
                message: "Uspješno ste obrisali klijenta.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })       

            this.getClientList()
            
        }
    }

    render(){      
        return(   
          <>  
          {this.props.loading ?
            <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                <Loader />
            </div>
          :
          this.props.clientList.totalNumberOfRecords > 0 ?
           
              <>
              
                <BootstrapTable
                    keyField="uuid" 
                    data={ this.props.clientList.clients } 
                    columns={ this.state.columns }   
                    bodyStyle={{wordBreak: 'break-word'} }                    
                />  
                 
                <div
                  className="row"
                  style={{
                    margin: "0 auto",
                    paddingTop: "10px"
                  }}
                >      
               
                  <Dropdown className="itemsPerPage">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      {this.props.pageSize}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => this.onItemsPerPageChange(10)}>10</Dropdown.Item>
                      <Dropdown.Item onClick={() => this.onItemsPerPageChange(20)}>20</Dropdown.Item>
                      <Dropdown.Item onClick={() => this.onItemsPerPageChange(30)}>30</Dropdown.Item>
                      <Dropdown.Item onClick={() => this.onItemsPerPageChange(50)}>50</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>   
   
                 
                  <Pagination
                    className="pagination"
                    firstPageText='1'
                    lastPageText={Math.ceil(this.props.clientList.totalNumberOfRecords/this.props.pageSize).toString()}
                    hideDisabled
                    activePage={this.props.activePage}
                    itemsCountPerPage={this.props.pageSize}
                    totalItemsCount={this.props.clientList.totalNumberOfRecords}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}                    
                  />
                
                </div>
               
                
            </>               
            : 
            <>
              <div style={{textAlign: "center", margin: "20px"}}>
                <h1>{this.props.message}</h1>
              </div>
              <div>
                               
                </div>

            </>      
            }

            

            <Modal
                isOpen={this.state.showModal}                
                onRequestClose={() => this.showModal("")}
                style={this.state.customStyles}
                contentLabel="Example Modal"
            >
 
                <h1 style={{padding:"20px"}}><strong>Upozorenje!</strong></h1>
            
                <div className="" style={{padding: "20px"}}>
                    Brisanjem klijenta brišu se i svi popratni podaci o njoj. Neki od podataka su  
                    poslovni prostori i naplatni uređaji.
                </div>

                <div className="row">
                    <div className="col col-sm-6">
                        <Button variant="primary" size="lg" onClick={() => this.showModal("")}>Zatvori</Button>
                    </div>
                    <div className="col col-sm-6">
                        <Button variant="danger" size="lg" onClick={() => this.confirmDelete()}> IZBRIŠI</Button>
                    </div>                
                </div>
            
         
            </Modal>                
          </>
        )}  
}

const mapStateToProps = state => {
  return {
      userLoggedIn: state.client.userLoggedIn,
      asideToggled: state.clientSettings.asideToggled,
      clientList: state.adminClient.clients,
      pageSize: state.adminClient.pageSize,
      activePage: state.adminClient.activePage,      
      loading: state.adminClient.loadingClients,
      message: state.adminClient.message,
      clientName: state.adminClient.clientName,
      clientAddress: state.adminClient.clientAddress
  };
};
  
const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data}),
    API: (type, data) => dispatch({ type: type, data: data})
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientList);
